import { AttachButton } from './utils/getAttachmentCommandItems';
import { ReplyWithEndpointType } from 'owa-mail-store';

export default {
    FPDualEntryComputer: {
        datapoint: {
            name: 'FPDualEntryComputer',
            customData: (entrySource: string) => ({ entrySource: entrySource }),
        },
    },
    FPDualEntryFilePicker: {
        datapoint: {
            name: 'FPDualEntryFilePicker',
            customData: (entrySource: string) => ({ entrySource: entrySource }),
        },
    },
    ComposeDropHint: {
        datapoint: {
            name: 'ComposeDropHint',
            customData: (dataTransferType: string) => [dataTransferType],
        },
    },

    ComposeCommandInsertSignature: {
        datapoint: {
            name: 'ComposeCommandInsertSignature',
        },
    },
    EditorTypingPerf: {
        datapoint: {
            name: 'EditorTypingPerf',
        },
    },

    AttachButtonClicked: {
        datapoint: {
            name: 'AttachButtonClicked',
            customData: (isMail: boolean) => [isMail],
        },
    },

    AttachButtonMenuOpened: {
        datapoint: {
            name: 'AttachButtonMenuOpened',
            customData: (
                suggestionProvider: ReplyWithEndpointType[],
                id: string[],
                rank: number[],
                provenance: string[],
                fileType: string[],
                defaultButtons: AttachButton[],
                isMail: boolean
            ) => [
                suggestionProvider.join(','),
                id.join(','),
                rank.join(','),
                provenance.join(','),
                fileType.join(','),
                defaultButtons.join(','),
                isMail,
            ],
        },
    },

    AttachButtonMenuClosed: {
        datapoint: {
            name: 'AttachButtonMenuClosed',
            customData: (isMail: boolean) => [isMail],
        },
    },

    AttachmentSuggestionClicked: {
        datapoint: {
            name: 'AttachmentSuggestionClicked',
            customData: (
                suggestionProvider: ReplyWithEndpointType,
                id: string,
                rank: number,
                provenance: string,
                fileType: string,
                generatedAttachmentId: string
            ): [any, any, any, any, any, any] => [
                suggestionProvider, // replyWith or MRU
                id, // file ID
                rank, // index of file
                provenance, // file location (use URL hostname)
                fileType, // file extension
                generatedAttachmentId, // used to track attachment across compose pane session
            ],
        },
    },
    AttachmentDragAndDrop: {
        datapoint: {
            name: 'AttachmentDragAndDrop',
            customData: (itemType: string) => [itemType],
        },
    },
};
